import { type FC } from 'react'
import { Typography } from '@mui/material'
import { hideVisually } from 'polished'

import { visuallyHiddenTypographyClasses } from './VisuallyHiddenLabel.constants'
import { type VisuallyHiddenLabelProps } from './VisuallyHiddenLabel.types'

const VisuallyHiddenLabel: FC<VisuallyHiddenLabelProps> = ({ component = 'span', label, children, ...rest }) => (
  <Typography
    {...rest}
    component={component}
    css={hideVisually()}
    classes={{ root: visuallyHiddenTypographyClasses.root }}
  >
    {label}
    {children}
  </Typography>
)

export default VisuallyHiddenLabel
